import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Building2 } from "lucide-react";

function resolveLogo(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}

export default function BuyerMarketplace() {
  const [vendors, setVendors] = useState([]);
  const [selected, setSelected] = useState(null);
  const [catalog, setCatalog] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/marketplace/vendors");
      setVendors(data);
    })();
  }, []);

  const openVendor = async (t) => {
    setSelected(t);
    const { data } = await api.get(`/marketplace/vendors/${t.id}/catalog`);
    setCatalog(data.items);
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="buyer-marketplace">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Vendor marketplace</h1>
        <p className="text-muted-foreground">Approved ceramic manufacturers on tilesphere.</p>
      </div>

      <div className="grid lg:grid-cols-3 gap-4">
        {vendors.map((v) => (
          <button key={v.id} onClick={() => openVendor(v)} className="surface-card p-5 text-left hover:-translate-y-1 hover:shadow-sm transition-all" data-testid={`vendor-card-${v.id}`}>
            <div className="flex items-center gap-3">
              {v.branding?.logo_url
                ? <img src={resolveLogo(v.branding.logo_url)} alt="" className="w-12 h-12 rounded-md object-cover border border-border" />
                : <div className="w-12 h-12 rounded-md grid place-items-center font-display font-black text-white" style={{ background: v.branding?.primary_color || "#C85A32" }}><Building2 className="w-5 h-5" /></div>}
              <div>
                <div className="font-display font-black">{v.branding?.company_name || v.name}</div>
                <div className="label-overline">{v.slug}</div>
              </div>
            </div>
            {v.address && <div className="text-xs text-muted-foreground mt-3 line-clamp-2">{v.address}</div>}
          </button>
        ))}
        {vendors.length === 0 && <div className="surface-card p-8 text-center text-sm text-muted-foreground col-span-3" data-testid="marketplace-empty">No approved vendors yet. Check back soon.</div>}
      </div>

      {selected && (
        <div className="surface-card p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="font-display text-xl font-bold">{selected.name} · Catalog</h2>
            <button onClick={() => { setSelected(null); setCatalog([]); }} className="text-sm text-muted-foreground hover:text-foreground" data-testid="close-catalog-btn">Close</button>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {catalog.map((c) => (
              <div key={c.id} className="border border-border rounded-md p-4">
                <div className="label-overline">{c.grade}</div>
                <div className="font-display font-bold mt-1">{c.name}</div>
                <div className="grid grid-cols-2 gap-2 mt-3 text-xs">
                  <div><div className="label-overline">Size</div><div className="font-mono">{c.tile_size}</div></div>
                  <div><div className="label-overline">Finish</div><div className="font-mono">{c.finish}</div></div>
                  <div><div className="label-overline">Batch</div><div className="font-mono">{c.batch_number}</div></div>
                  <div><div className="label-overline">Shade</div><div className="font-mono">{c.shade_code}</div></div>
                </div>
                <div className="mt-3 flex justify-between text-sm">
                  <span className="font-mono">{c.boxes_available} boxes</span>
                  <span className="font-display font-bold text-primary">₹{Number(c.price_per_box).toLocaleString()}</span>
                </div>
              </div>
            ))}
            {catalog.length === 0 && <div className="text-sm text-muted-foreground col-span-3">No items yet from this vendor.</div>}
          </div>
        </div>
      )}
    </div>
  );
}
